import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-padding-y" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "app-padding" }, "Troubleshooting Content", -1)

import VHeader from '../shared/VHeader.vue'

import { dismissCurrentModal } from '@/helpers/modal'

export default /*#__PURE__*/_defineComponent({
  __name: 'TroubleshootingModal',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(VHeader, {
      class: "app-padding-x sign-up-header",
      title: _ctx.$t('troubleshooting.title'),
      onBack: _unref(dismissCurrentModal)
    }, null, 8, ["title", "onBack"]),
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    })
  ]))
}
}

})